import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useApi, errMsg } from "@/lib/api";
import { Logo } from "@/components/layout/Navbar";

const COLS = [
  ["Marketplace", [["/services", "Services"], ["/products", "Digital products"], ["/developers", "Developers"], ["/agencies", "Agencies"], ["/projects", "Projects"], ["/categories", "Categories"]]],
  ["Company", [["/about", "About"], ["/pricing", "Pricing & fees"], ["/blog", "Blog"], ["/contact", "Contact"]]],
  ["Support", [["/help", "Help center & FAQ"], ["/legal/terms", "Terms & conditions"], ["/legal/privacy", "Privacy policy"], ["/legal/refunds", "Refund & cancellation"], ["/legal/shipping", "Shipping & delivery"], ["/contact", "Contact us"]]],
];

export default function Footer() {
  const api = useApi();
  const [email, setEmail] = useState("");
  const sub = async (e) => {
    e.preventDefault();
    try { await api.post("/newsletter", { email }); toast.success("Subscribed — thanks!"); setEmail(""); }
    catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <footer className="mt-24 border-t border-border bg-[hsl(var(--surface))]">
      <div className="container-x grid gap-12 py-16 md:grid-cols-12">
        <div className="md:col-span-4">
          <Logo />
          <p className="mt-4 max-w-sm text-sm text-muted-foreground">The marketplace for developer services, project hiring and digital products. Secure payments in Indian Rupees (₹).</p>
          <form onSubmit={sub} className="mt-6 flex max-w-sm gap-2" data-testid="newsletter-form">
            <Input type="email" required placeholder="you@company.com" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="newsletter-email-input" />
            <Button type="submit" data-testid="newsletter-submit-button">Subscribe</Button>
          </form>
        </div>
        {COLS.map(([h, links]) => (
          <div key={h} className="md:col-span-2 md:col-start-auto">
            <h4 className="mb-4 text-sm font-semibold">{h}</h4>
            <ul className="space-y-2.5">{links.map(([to, l]) => <li key={to}><Link to={to} className="text-sm text-muted-foreground transition-colors hover:text-foreground">{l}</Link></li>)}</ul>
          </div>
        ))}
      </div>
      <div className="container-x flex flex-col gap-2 border-t border-border py-6 text-xs text-muted-foreground sm:flex-row sm:justify-between">
        <span>© {new Date().getFullYear()} DevMarket · Operated by XETCX TECHNOLOGY PRIVATE LIMITED (CIN U47912BR2026PTC087622) · Patna, Bihar.</span>
        <span>All prices in Indian Rupees (₹).</span>
      </div>
    </footer>
  );
}
